import React, { FC } from 'react';
import Select from 'antd/lib/select';
import { SelectProps } from './typings';
import './style.scss';

const { Option } = Select;

const SelectDropdown: FC<SelectProps> = (props) => {
  const {
    placeholder,
    onChange,
    defaultValue,
    optionList,
    disabled,
    wrapperClass,
    value,
    parentId,
    DropdownIcon,
    error,
    errorMessage,
    enableSearch,
    bordered = false,
    customStyle = {},
  } = props;
  const getElement = (id: string): HTMLElement => {
    return document.getElementById(id) || document.body;
  };

  return (
    <>
      <div className={`filter-dropdown ${wrapperClass}`}>
        <Select
          style={Object.keys(customStyle).length ? {...customStyle} : {}}
          showSearch={enableSearch}
          suffixIcon={DropdownIcon && DropdownIcon}
          defaultValue={defaultValue}
          value={value}
          onChange={(e) => onChange(e)}
          placeholder={placeholder}
          disabled={disabled}
          bordered={bordered}
          getPopupContainer={(trigger) => {
            parentId ? () =>  getElement(parentId) : undefined;
            return trigger;
          }}
          optionFilterProp='children'
          filterOption={(input, option:any) => {
            return option?.value?.toLowerCase().includes(input.toLowerCase());
          }}
        >
          {optionList &&
            optionList.length > 0 &&
            optionList.map((item, index) => (
              <Option key={index} value={item.value}>
                {item.label}
              </Option>
            ))}
        </Select>
        {error && <div className='error'>{errorMessage}</div>}
      </div>
    </>
  );
};

export default SelectDropdown;
